<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 检查管理 > 体质评估
			</div>
			<div class="con">
				<div class="item">
					<div class="line">
						<p class="blue">
							<span>请选出符合您目前实际情况的选项 ？（最多选择2项）</span>
							<img src="../../../static/images/bluebg.png" />
						</p>
						<div class="radio">
							<el-checkbox-group
							:max="2"
							 @change="coatingNatureChange" v-model="checkList">
							    <el-checkbox							    	
							    	v-for="(item,index) in phyList" :key="index"
							    	 :value="item"
							    	 :label="item"
							    	 :disabled="item.disabled">
							    	 {{item.question}}
							    </el-checkbox>							    
							</el-checkbox-group> 							
						</div>						
					</div>
				</div>
				<div class="bottom">
					<!-- <div class="btn" @click="pre">上一步</div> -->
					<div class="btn" @click="next">下一步</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				checkList:[],
				visitId:'',
				phyList:[]				
			};
		},

		methods: {
			pre(){
				this.$message.warning('舌面采集功能已移除');
			},
			//下一步
			next(){
				if(this.checkList.length>0){
					let list = [];
					for(let i = 0;i<this.checkList.length;i++){
						list.push(this.checkList[i].physique)
					}
					this.phySiqueAdd(list);
					this.removeLocal();
				}else{
					this.$message("请选出符合您目前实际情况的选项");
				}
			},
			//确定体质
			phySiqueAdd(list){				
				this.$applicationJson("/business/visit/physique/add", {
						visitId:this.visitId,
						physiqueList:list
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.$router.push({
							  path: '/historyList/viewReport',
							  query: {
							     visitId: this.visitId,
							  }
							}); 	
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取体质维护
			getPlanList(currentPage) {
				this.$applicationJson("/business/basePhysiqueQuestion/paging", {
						current: currentPage,
						orderBy: "",
						params: {},						
						size: 100,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.phyList = res.data.data.records;
							for(let i = 0;i<this.phyList.length;i++){
								this.phyList[i].disabled = false
							}	
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//切换
			coatingNatureChange(r){
				for(let i = 0;i<this.phyList.length;i++){
					this.phyList[i].disabled = false
				}
				if(r.length>0){
					if (this.checkList[0].question.indexOf('正常') > -1) {
						this.phyList[this.phyList.length-1].disabled = false
						for(let i = 0;i<this.phyList.length-1;i++){
							this.phyList[i].disabled = true
						}	
						this.$forceUpdate()				
						return;
					}else{						
						if(this.checkList.length==0){
							this.phyList[this.phyList.length-1].disabled = false
						}else{
							this.phyList[this.phyList.length-1].disabled = true;
						} 
						this.$forceUpdate()						
					}
				}else{
					 for(let i = 0;i<this.phyList.length;i++){
						this.phyList[i].disabled = false
					}
					this.$forceUpdate() 
				}			
			},
			removeLocal(){
			}
		},

		created() {
			this.$nextTick(() => {
				this.visitId = this.$route.query.visitId;
				this.getPlanList(0);
			});
		},
		mounted() {

		},
		
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";

	.independent-wrapper {
		overflow-y: auto;
		position: relative;
		overflow-x: hidden;
		width: 100%;
		position: relative;
		background: url('../../../static/images/smy/ceping_bg.png') no-repeat 0px 30px;
		background-size:100%;
		z-index: 2;
		.con {
			background: #fefefe;
			box-shadow: 0px 3px 4px 0px rgba(204, 204, 204, 0.25);
			border-radius: 8px;
			border: 1px solid #e5e5e5;
			width:700px;
			background: #fff;
			padding: 0 20px;
			z-index: 1;
			margin: 150px auto;
			
			.item{
				width: 100%;
				margin-top: 10px;				
				.line{
					margin-bottom: 20px;
					padding: 0 80px;
					width: calc(100% - 160px);
					p{
						line-height: 40px;
					}
					.blue{
						position: relative;
						height: 40px;
						span{
							    position: absolute;
							    top: 5px;
								z-index: 2;
								font-size: 14px;
						}
						img{
							position:absolute;
							bottom: 8px;
							width: 328px;
						}
						
					}
					.el-checkbox{
						width: 100%;
						padding: 15px 0px;
						border-bottom: 1px dashed #999;
					}
				}
			}
			.bottom {
				width: 100%;
				margin-top: 60px;
				bottom: 40px;
				margin-bottom: 20px;
				text-align: center;
				.btn {
					width: 200px;
					height: 50px;
					background: #679FF6;
					border-radius: 4px;
					text-align: center;
					line-height: 50px;
					font-size: 16px;
					margin: 0 auto;
					color: #fff;
					cursor: pointer;
					display: inline-block;
					margin-right: 20px;
				}
			}
		}
	}
</style>
